// Create audio instances for reuse
const successSound = new Audio('/sounds/success.mp3');
const errorSound = new Audio('/sounds/error.mp3');

// Configure audio settings
successSound.volume = 0.5;
errorSound.volume = 0.4;

export const playSound = {
  success: () => {
    successSound.currentTime = 0; // Reset to start
    successSound.play().catch(err => console.log('Audio playback failed:', err));
  },
  error: () => {
    errorSound.currentTime = 0; // Reset to start
    errorSound.play().catch(err => console.log('Audio playback failed:', err));
  }
};